import Madlib from './Madlib';

export default Madlib;
